import type { ReactNode } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { Card } from '@/components/ui'
import { usePedagogyAccess } from '@/hooks/usePedagogyAccess'
import { pedagogyPaths } from '@/lib/pedagogyRoutes'
import { useAuthStore } from '@/store'

/**
 * Lead/advanced-only surfaces: role, KPI and specialist assignment management.
 *
 * A pedagogy specialist may additionally open their own operational card. The
 * backend RPCs enforce the same rule; keeping it here prevents the UI from
 * advertising a link that the route immediately redirects away from.
 */
export function PedagogyAdminRouteGuard({
  children,
  allowOwnSpecialistPage = false,
}: {
  children: ReactNode
  allowOwnSpecialistPage?: boolean
}) {
  const { loading, canManagePedagogy } = usePedagogyAccess()
  const { specialistUserId } = useParams<{ specialistUserId?: string }>()
  const userId = useAuthStore(state => state.user?.id)
  const canOpenOwnSpecialistPage = allowOwnSpecialistPage
    && Boolean(userId && specialistUserId === userId)

  if (loading) {
    return (
      <div className="space-y-4 pb-24">
        <Card><div className="py-10 text-center text-sm text-muted-foreground">Проверяем доступ…</div></Card>
      </div>
    )
  }

  if (!canManagePedagogy && !canOpenOwnSpecialistPage) {
    return <Navigate to={pedagogyPaths.department} replace />
  }
  return <>{children}</>
}
